import CryptoJS from "crypto-js";
import { key } from "../../constants";
export const decryptData = (data: any) => {
  const decryptBytes = CryptoJS.AES.decrypt(data, key);
  const original = decryptBytes.toString(CryptoJS.enc.Utf8);
  return original;
};
